import { Component, OnInit } from '@angular/core';
import {DOCUMENT_TYPES} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {paramsHelper} from "../../helpers/params-helper";
import {IDocument} from "../../interfaces/document.definition";
import {BusService} from "../../services/bus.service";
import {JP} from "../../helpers/jp";
import {FactoryService} from "../../services/factory.service";
import {IOnmapDialog, IParticipant, IPhrase, ITag} from "../../services/factory-service-impl/onmap-dialog.utils";
import {isUndefined} from "util";
import {GO_CATEGORIES, GO_CATEGORIES_LIST} from "../../enums/e-game-objects";
import {ONMAP_TAGS, ONMAP_TAGS_LIST} from "../../enums/e-onmap-tags";
import {CollectionService} from "../../services/collection.service";
import {VALUE_TYPE} from "../../enums/enums";
import {localeUtils} from "../../helpers/locale-utils";
import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {WatchService} from "../../services/watch.service";
import {Subject} from "rxjs/Subject";

@Component({
  selector: 'app-onmap-dialogs',
  templateUrl: './onmap-dialogs.component.html',
  styles: []
})
export class OnmapDialogsComponent implements OnInit {

  UI_TEXTS = UI_TEXTS;
  GO_CATEGORIES_LIST = GO_CATEGORIES_LIST;
  ONMAP_TAGS_LIST = ONMAP_TAGS_LIST;
  VAL_TYPES = VALUE_TYPE;

  pageParams = paramsHelper.page()
    .setTitle("На карте");

  document: IOnmapDialog;
  selectedParticipant: IParticipant;
  selectedTag: ITag;
  selectedPhrase: IPhrase;
  participantCategoryIds: IDocument[] = [];
  loadedIds: IDocument[] = [];
  private unsubscribe: Subject<void> = new Subject<void>();


  helpers = {
    getLabel: this.doGetLabel
  };

  collectionParams = paramsHelper.collection()
    //.setDuplicateEnabled(false)
    .setDefaultListLabels()
    .setItemLabelQueryHelpers(this.helpers)
    //.setItemLabelQuery('phrases[0]:getLabel')
    .setItemLabelQuery(`locales.${localeUtils.getLocale()}.[key=name].value.0`)
    .setObjectType(DOCUMENT_TYPES.ONMAP_DIALOG)
    .setSearchParams(paramsHelper.search()
      .addParam(`phrases.locales.${localeUtils.getLocale()}.text`, SEARCH_PROP_TYPES.LOCALE, ""));

  noneId: IDocument =
    {
      _id: "none",
      id: -1
    }


  constructor(private busService: BusService,
              private factoryService: FactoryService,
              private collectionService: CollectionService,
              private watchService: WatchService) {

  }

  get participants() {
    return JP.get(this.document, '/participants');
  }

  get tags() {
    return JP.get(this.document, '/tags');
  }

  get phrases() {
    return JP.get(this.document, '/phrases');
  }

  onParticipantAdd() {
    this.factoryService.onmapUtils.addParticipantTo(this.document);
  }

  onTagAdd() {
    this.factoryService.onmapUtils.addTagTo(this.document);
  }

  onPhraseAdd() {
    this.factoryService.onmapUtils.addPhraseTo(this.document);
  }

  getParticipantLabel(p: IParticipant) {
    return p.category + ((isUndefined(p.id) || p.id == -1) ? '' : `_${p.id}`);
  }

  getTagLabel(t: ITag) {
    return t.tag + (isUndefined(t.category) ? '' : `_${t.category}`) + ((isUndefined(t.id) || t.id == -1) ? '' : `_${t.id}`) + `@${t.count}`;
  }

  getPhraseLabel(ph: IPhrase) {
    return localeUtils.findValue("text", ph);
  }

  getParticipantsList(participants: IParticipant[]) {
    return participants.map((p, i) => {
      return {id: i, label: this.getParticipantLabel(p)}
    });
  }

  onParticipantSelected(p) {
    this.selectedParticipant = p;
    this.loadParticipantCategoryIdsIfNeeded();
  }

  onTagSelected(t) {
    this.selectedTag = t;
    this.onTagTagChange();
  }

  onPhraseSelected(ph) {
    this.selectedPhrase = ph;
  }

  onParticipantCategoryChange() {
    delete this.selectedParticipant.id;
    this.loadParticipantCategoryIdsIfNeeded();
  }

  onTagTagChange() {
    if (this.selectedTag != null) {
      if (this.tagNeedsCategory(this.selectedTag.tag)) {
        if (isUndefined(this.selectedTag.category)) {
          this.selectedTag.category = GO_CATEGORIES.SHMU;
        }
        this.loadTagCategoryIdsIfNeeded();
      }
      else if (this.tagNeedsId(this.selectedTag.tag)) {
        delete this.selectedTag.category;
        this.loadTagIdsIfNeeded();
      }
      else {
        delete this.selectedTag.category;
        delete this.selectedTag.id;
      }
    }
  }

  onTagCategoryChange() {
    delete this.selectedTag.id;
    this.loadTagCategoryIdsIfNeeded();
  }

  /*ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(e => this.updateDocument(e.document as IOnmapDialog));
  }*/

  ngOnInit() {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.updateDocument(e.document as IOnmapDialog));

    this.watchService.docChanged()
      .takeUntil(this.unsubscribe)
      .subscribe(hasChanges => {
        if (hasChanges) {
          this.updateDocument(this.document);
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  getDocumentId(d: IDocument): string {
    return d.id.toLocaleString();
  }

  private doGetLabel(p: IPhrase): string {
    if (p != null && !isUndefined(p)) {
      //console.log(p);
      return localeUtils.findValue("text", p);
    }
    else {
      return "Пустой";
    }
  }

  private updateDocument(document: IOnmapDialog) {
    this.document = document;
    if (document !== null) {
      if (isUndefined(this.document['locales'])) {
        this.document['locales'] = {};
      }
      if (document.phrases != null && document.phrases.length > 0) {
        this.document['locales'][localeUtils.getLocale()] = [{
          key: "name",
          value: [this.doGetLabel(document.phrases[0])]
        }];
      }

      //console.log(this.document['locales'][localeUtils.getLocale()]);
    }
  }

  private loadParticipantCategoryIdsIfNeeded() {
    let p = this.selectedParticipant;
    if (p != null && !isUndefined(p) && this.categoryNeedsId(p.category)) {
      this.loadCategoryIds(p.category).then(ids => {
        this.participantCategoryIds = [this.noneId].concat(ids);
        if (ids.length > 0 && isUndefined(this.selectedParticipant.id)) {
          this.selectedParticipant.id = this.participantCategoryIds[0].id;
        }
      });
    }
  }

  private loadTagCategoryIdsIfNeeded() {
    let t = this.selectedTag;
    if (t != null && !isUndefined(t)) {
      this.loadCategoryIds(t.category).then(ids => {
        this.loadedIds = [this.noneId].concat(ids);
        if (ids.length > 0 && isUndefined(this.selectedTag.id)) {
          this.selectedTag.id = this.loadedIds[0].id;
        }
      });
    }
  }

  private  loadTagIdsIfNeeded() {
    let t = this.selectedTag;
    if (t != null && !isUndefined(t))
    {
      this.loadTagIds(t.tag).then(ids => {
        console.log(ids);
        this.loadedIds = [this.noneId].concat(ids);
        if (ids.length > 0 && isUndefined(this.selectedTag.id)){
          this.selectedTag.id = this.loadedIds[0].id;
          console.log(this.selectedTag.id);
        }
      })
    }
  }

  private loadCategoryIds(category: string): Promise<IDocument[]> {
    const search = paramsHelper
      .search()
      .addStringParam("category", category)
      .json;

    const params = paramsHelper
      .loader()
      .setEndpointApi()
      .setObjectType(DOCUMENT_TYPES.GO)
      .setNavParams(0, 9999)
      .setSearchParams(search);

    var promise: Promise<IDocument[]> = new Promise<IDocument[]>((resolve =>
        this.collectionService.loadChunkCached(params)
          .subscribe(
            r => {
              resolve(r.documents);
            })
    ));
    return promise;
  }

  private loadTagIds(tag: string):Promise<IDocument[]> {
    var type:string;
    switch (tag)
    {
      case ONMAP_TAGS.QUEST_COMPLETED:
      case ONMAP_TAGS.INV_QUEST_COMPLETED:
        type = "quest";
        break;
      default:
        type = "";
    }
    if (type != "")
    {
      const search = paramsHelper
        .search()
        .addStringParam("_type", type)
        .json;

      const params = paramsHelper
        .loader()
        .setEndpointApi()
        .setNavParams(0, 9999)
        .setSearchParams(search);

      var promise: Promise<IDocument[]> = new Promise<IDocument[]>((resolve =>
          this.collectionService.loadChunkCached(params)
            .subscribe(
              r => {
                resolve(r.documents);
              })
      ));
      return promise;
    }
    return Promise.resolve([]);
  }

  private categoryNeedsId(category: string): boolean {
    let res: boolean = false;
    switch (category) {
      case GO_CATEGORIES.SHMU:
        res = false;
        break;
      default:
        res = true;
    }
    return res;
  }

  private tagNeedsCategory(tag: string): boolean {
    let res: boolean = false;
    switch (tag) {
      case ONMAP_TAGS.QUEST_COMPLETED:
      case ONMAP_TAGS.INV_QUEST_COMPLETED:
      case ONMAP_TAGS.SECTOR_UNLOCKED:
      case ONMAP_TAGS.DAILY_QUEST_COMPLETED:
      case ONMAP_TAGS.MARKET_ORDER_COMPLETED:
      case ONMAP_TAGS.LEVEL_UP:
      case ONMAP_TAGS.RUBIES_SPENT:
      case ONMAP_TAGS.DIRIGIBLE_ARRIVED:
      case ONMAP_TAGS.DIRIGIBLE_EXPIRED:

        res = false;
        break;
      default:
        res = true;
    }
    return res;
  }

  private tagNeedsId(tag: string): boolean
  {
    let res:boolean = false;
    switch (tag) {
      case ONMAP_TAGS.QUEST_COMPLETED:
      case ONMAP_TAGS.INV_QUEST_COMPLETED:
        res = true;
        break;
      default:
        res = false;
    }
    return res;
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/onmap-dialogs/onmap-dialogs.component.ts